import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { TimeSheetWorklistInfo } from '../model/timesheetWorklist.model';
import { LookupInfo } from '../model/lookup.model';
import { ActivatedRoute } from '@angular/router';
import { TimeSheetDetailInfo } from '../model/timesheetDetailInfo.model';

@Component({
  selector: 'app-timesheet-worklist',
  templateUrl: './timesheet-worklist.component.html',
  styleUrls: ['./timesheet-worklist.component.css']
})
export class TimesheetWorklistComponent implements OnInit {

  baseurl: string;
  _EmpCode: string;
  _EmpRole: string;
  isSubmitted: any;

  //Primary data
  ListTimesheetMyDraft: TimeSheetWorklistInfo[] = [];
  ListTimesheetPending: TimeSheetWorklistInfo[] = [];
  ListTimesheetApproved: TimeSheetWorklistInfo[] = [];
  ListTimesheetRequest: TimeSheetWorklistInfo[] = [];
  ListTimesheetCompleted: TimeSheetWorklistInfo[] = [];
  ListTimesheetSubmitPreview: TimeSheetWorklistInfo[] = [];
  ListTimesheetSubmitPreviewId: number[];

  //Pending Modal
  ListTimesheetIncompleteDaysPromise: Promise<TimeSheetDetailInfo[]>;
  ListTimesheetIncompleteDays: TimeSheetDetailInfo[] = [];
  TimesheetCodeIncompleteDay: string;
  TimesheetUnfilledDayCount: number = 0;

  //Search Conditions
  ListTimesheetStatus: LookupInfo[] = [];

  txtSchTimesheetStatus: string = "";
  txtSchTimesheetCode: string = "";

  //Pagination

  currentTab: any = "Worklist";
  currentIndex = 0;
  initializedWorklist: boolean = false;
  initializedApproval: boolean = false;

  indexNoMyDraft: number = 0;
  currentPageNumberMyDraft: number = 1;
  totalTimesheetsMyDraft: number = 0;
  totalPagesMyDraft: number = 0;

  indexNoPending: number = 0;
  currentPageNumberPending: number = 1;
  totalTimesheetsPending: number = 0;
  totalPagesPending: number = 0;

  indexNoApproved: number = 0;
  currentPageNumberApproved: number = 1;
  totalTimesheetsApproved: number = 0;
  totalPagesApproved: number = 0;

  indexNoRequest: number = 0;
  currentPageNumberRequest: number = 1;
  totalTimesheetsRequest: number = 0;
  totalPagesRequest: number = 0;

  indexNoCompleted: number = 0;
  currentPageNumberCompleted: number = 1;
  totalTimesheetsCompleted: number = 0;
  totalPagesCompleted: number = 0;


  pageSize: number = 5;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private activatedRoute: ActivatedRoute, private location: Location) {
    this.baseurl = environment.base_api;

    this.activatedRoute.params.subscribe(params => {
      this.currentTab = (params['Tab']) ?? this.currentTab;
    });

    GlobalService.CheckPagingAccessRights();
  }

  // ngOnInit - start
  // ========================================================================================================
  ngOnInit(): void {

    this._EmpCode = localStorage.getItem("EmpCode");
    debugger
    this._EmpRole = localStorage.getItem('EmpRoleCode');

    this.currentPageNumberMyDraft = 1;
    this.currentPageNumberPending = 1;
    this.currentPageNumberApproved = 1;
    this.currentPageNumberRequest = 1;
    this.currentPageNumberCompleted = 1;
    this.pageSize = environment.PageSizeSmall;


    this.LoadLookup('TIMESHEETSTATUS').then((data) => {
      this.ListTimesheetStatus = data.filter(x => x.LookupCode == "3" || x.LookupCode == "5");
    });

    this.LoadCurrentTabTimesheetLists();
  }
  // ngOnInit - end
  // ========================================================================================================


  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadTimesheetList(filter: number = 0) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['TimeSheetStatus'] = this.checkUndefinedString(this.txtSchTimesheetStatus);
      objectjson['TimeSheetCode'] = this.checkUndefinedString(this.txtSchTimesheetCode);
      objectjson['rowFetch'] = environment.PageSizeSmall;

      if (filter == 1) objectjson['rowOFFSet'] = (this.currentPageNumberMyDraft - 1) * environment.PageSizeSmall;
      if (filter == 2) objectjson['rowOFFSet'] = (this.currentPageNumberPending - 1) * environment.PageSizeSmall;
      if (filter == 3) objectjson['rowOFFSet'] = (this.currentPageNumberApproved - 1) * environment.PageSizeSmall;
      if (filter == 4) objectjson['rowOFFSet'] = (this.currentPageNumberRequest - 1) * environment.PageSizeSmall;
      if (filter == 5) objectjson['rowOFFSet'] = (this.currentPageNumberCompleted - 1) * environment.PageSizeSmall;

      objectjson['TimeSheetTaskFilter'] = filter;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetWorklistInfo[]>(this.baseurl + "TimeSheet/GetWorklist",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (filter == 1) this.ListTimesheetMyDraft = data;
            if (filter == 2) this.ListTimesheetPending = data;
            if (filter == 3) this.ListTimesheetApproved = data;
            if (filter == 4) this.ListTimesheetRequest = data;
            if (filter == 5) this.ListTimesheetCompleted = data;

            this.SetTotalpagePagination(filter, data.length > 0 ? data[0].rowCount: 0);

            //this.LoadCountTimesheetList(filter).then(count => {
            //  this.SetTotalpagePagination(filter,count);
            //});

            this.ListTimesheetSubmitPreview = null;

            setTimeout(() => { this.Loading(false, ''); }, 500);
          }
        });
    }
  }

  async LoadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async SendTimesheetForApproval(listTimesheetId: number[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ListOfId'] = listTimesheetId;
      objectjson['UpdateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetWorklistInfo[]>(this.baseurl + "TimeSheet/SubmitForApproval",
          strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + this.isSubmitted);
            $('#ModalSubmitComplete').modal();
            this.LoadAllTimesheetLists();
       });
    }
  }

  async LoadAllTimesheetLists() {
    this.LoadTimesheetList(1);
    this.LoadTimesheetList(2);
    this.LoadTimesheetList(3);
    this.LoadTimesheetList(4);
    this.LoadTimesheetList(5);

    //this.LoadCountAllTables();
  }

  async LoadWorklistTimesheetLists() {
    this.LoadTimesheetList(1);
    this.LoadTimesheetList(2);
    this.LoadTimesheetList(3);
  }

  async LoadApproveTimesheetLists() {
    this.LoadTimesheetList(4);
    this.LoadTimesheetList(5);
  }

  async LoadCurrentTabTimesheetLists(reinitialized:boolean = false) {
    if (this.currentTab == 'Worklist') {
      if (reinitialized) this.initializedWorklist = false;
      if (!this.initializedWorklist) this.LoadWorklistTimesheetLists().then(() => this.initializedWorklist = true);
      this.currentIndex = 0;
      this.location.go("/timesheet-worklist;Tab=Worklist");
    } else if (this.currentTab == 'Approval') {
      if (reinitialized) this.initializedApproval = false;
      if (!this.initializedApproval) this.LoadApproveTimesheetLists().then(() => this.initializedApproval = true);
      this.currentIndex = 1;
      this.location.go("/timesheet-worklist;Tab=Approval");
    }
  }

  selectedTabChange(traget) {
    //if (traget.tab.textLabel == 'Worklist') {
    //  this.LoadWorklistTimesheetLists();
    //} else if (traget.tab.textLabel == 'Approval') {
    //  this.LoadApproveTimesheetLists();
    //}
    this.currentTab = traget.tab.textLabel;
    this.LoadCurrentTabTimesheetLists();
  }

  async getTimesheetIncompleteDays(): Promise<TimeSheetDetailInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var objectjson = {};

      objectjson['TimeSheetCode'] = this.TimesheetCodeIncompleteDay;
      objectjson['EmployeeCode'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.ListTimesheetIncompleteDaysPromise = this.httpClient
        .post<TimeSheetDetailInfo[]>(this.baseurl + "TimeSheet/GetTimesheetIncompleteDays",
          strjson, httpOptions)
        .toPromise()

      return this.ListTimesheetIncompleteDaysPromise;
    }
  }

  // Primary-Data Functions - end
  // ========================================================================================================

  // Data-Count - start
  // ========================================================================================================
  async LoadCountAllTables() {
    //this.LoadCountTimesheetList(1);
    //this.LoadCountTimesheetList(2);
    //this.LoadCountTimesheetList(3);
    //this.LoadCountTimesheetList(4);
    //this.LoadCountTimesheetList(5);
  }

  async LoadCountTimesheetList(filter: number = 0) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['TimeSheetStatus'] = this.checkUndefinedString(this.txtSchTimesheetStatus);
      objectjson['TimeSheetCode'] = this.checkUndefinedString(this.txtSchTimesheetCode);
      objectjson['TimeSheetTaskFilter'] = filter;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "TimeSheet/GetCountWorklist",
          strjson, httpOptions)
        .toPromise();
    }
  }
  // Data-Count - end
  // ========================================================================================================


  // Pagination - start
  // ========================================================================================================
  SetTotalpagePagination(list, data) {
    if (list == 1) {
      this.totalTimesheetsMyDraft = data;
      if (this.totalTimesheetsMyDraft == 0) {
        this.currentPageNumberMyDraft = 0;
      }
      this.totalPagesMyDraft = Math.ceil(this.totalTimesheetsMyDraft / environment.PageSizeSmall);
    }
    if (list == 2) {
      this.totalTimesheetsPending = data;
      if (this.totalTimesheetsPending == 0) {
        this.currentPageNumberPending = 0;
      }
      this.totalPagesPending = Math.ceil(this.totalTimesheetsPending / environment.PageSizeSmall);
    }
    if (list == 3) {
      this.totalTimesheetsApproved = data;
      if (this.totalTimesheetsApproved == 0) {
        this.currentPageNumberApproved = 0;
      }
      this.totalPagesApproved = Math.ceil(this.totalTimesheetsApproved / environment.PageSizeSmall);
    }
    if (list == 4) {
      this.totalTimesheetsRequest = data;
      if (this.totalTimesheetsRequest == 0) {
        this.currentPageNumberRequest = 0;
      }
      this.totalPagesRequest = Math.ceil(this.totalTimesheetsRequest / environment.PageSizeSmall);
    }
    if (list == 5) {
      this.totalTimesheetsCompleted = data;
      if (this.totalTimesheetsCompleted == 0) {
        this.currentPageNumberCompleted = 0;
      }
      this.totalPagesCompleted = Math.ceil(this.totalTimesheetsCompleted / environment.PageSizeSmall);
    }
  }
  OnLoadListFinished(list,traget = null) {
    if (traget != null && list == 1) { // check call function from change page or onloadfrist
      this.currentPageNumberMyDraft = traget.currentPageNumber;
      this.totalPagesMyDraft = traget.totalPages;
      this.indexNoMyDraft = traget.index;
    }
    if (traget != null && list == 2) { // check call function from change page or onloadfrist
      this.currentPageNumberPending = traget.currentPageNumber;
      this.totalPagesPending = traget.totalPages;
      this.indexNoPending = traget.index;
    }
    if (traget != null && list == 3) { // check call function from change page or onloadfrist
      this.currentPageNumberApproved = traget.currentPageNumber;
      this.totalPagesApproved = traget.totalPages;
      this.indexNoApproved = traget.index;
    }
    if (traget != null && list == 4) { // check call function from change page or onloadfrist
      this.currentPageNumberRequest = traget.currentPageNumber;
      this.totalPagesRequest = traget.totalPages;
      this.indexNoRequest = traget.index;
    }
    if (traget != null && list == 5) { // check call function from change page or onloadfrist
      this.currentPageNumberCompleted = traget.currentPageNumber;
      this.totalPagesCompleted = traget.totalPages;
      this.indexNoCompleted = traget.index;
    }

    this.LoadAllTimesheetLists();
  }
  // Pagination - end
  // ========================================================================================================

  // OnEvent - start
  // ========================================================================================================
  OnSearch_Click() {
    this.currentPageNumberMyDraft = 1;
    this.currentPageNumberPending = 1;
    this.currentPageNumberApproved = 1;
    this.currentPageNumberRequest = 1;
    this.currentPageNumberCompleted = 1;

    this.LoadCurrentTabTimesheetLists(true);
    //this.LoadAllTimesheetLists();
    //this.LoadCountTimesheetList();
  }
  OnClear_Click() {
    this.txtSchTimesheetStatus = "";
    this.txtSchTimesheetCode = "";
    this.currentPageNumberMyDraft = 1;
    this.currentPageNumberPending = 1;
    this.currentPageNumberApproved = 1;
    this.currentPageNumberRequest = 1;
    this.currentPageNumberCompleted = 1;


    this.LoadCurrentTabTimesheetLists(true);
    //this.LoadAllTimesheetLists();
    //this.LoadCountTimesheetList();
  }
  OnSendTimesheet_Click() {
    if (this.ListTimesheetSubmitPreview.length === 0) return;
    $('#ModalTimesheetSubmitPreview').modal('show');
  }
  OnTimesheetPreviewSubmit_Click() {
    this.SendTimesheetForApproval(this.ListTimesheetSubmitPreviewId);
  }
  OnCheckInCompleteDay_Click(tscode, taskStamp: string) {

    this.TimesheetUnfilledDayCount = parseInt(taskStamp.split('/')[0]);

    this.TimesheetCodeIncompleteDay = tscode;

    this.getTimesheetIncompleteDays()
      .then(
        data => {
          this.ListTimesheetIncompleteDays = data;
          $('#ModalTimesheetIncompleteDays').modal('show');
        }
     );
  }
  // OnEvent - end
  // ========================================================================================================

  // Misc functions - start
  // ========================================================================================================
  Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }
  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxTimesheetWorklist"]').filter(function () {
      return !(this as HTMLInputElement).disabled
    }).prop('checked', check);

    this.updatesubmitpreview();
  }
  updatesubmitpreview() {
    var listselected = $('[name="checkboxTimesheetWorklist"]:checked').filter(function () {
      return !(this as HTMLInputElement).disabled
    });

    this.ListTimesheetSubmitPreviewId = [];

    for (var x = 0; x < listselected.length; x++){
      this.ListTimesheetSubmitPreviewId.push(Number((<HTMLInputElement>listselected[x]).value));
    }

    this.ListTimesheetSubmitPreview = this.ListTimesheetMyDraft.filter(sheet => this.ListTimesheetSubmitPreviewId.includes(sheet.Id));
  }
  // Misc functions - end
  // ========================================================================================================

}
